<template>
    <Head title="ActivityLog" />
    <div id="accordion">
        <div class="card card-primary">
            <div class="card-header">
                <h4 class="card-title w-100">
                    <a class="d-block w-100" data-toggle="collapse" href="#collapseOne">
                        SARING DATA
                    </a>
                </h4>
            </div>
            <div id="collapseOne" class="collapse" data-parent="#accordion">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm">
                            <input-text label="Operator" name="operator" class="form-control filter-input" />
                        </div>
                        <div class="col-sm">
                            <input-text label="Diskripsi" name="description" class="form-control filter-input" />
                        </div>
                        <div class="col-sm">

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="card card-outline card-primary">
        <div class="card-header">
            <h3 class="card-title">ACTIVITY LOG</h3>
            <div class="card-tools">
                <Link href="/home" class="btn btn-tool"><i class="fas fa-times"></i></Link>
            </div>
        </div>
        <div class="card-body table-responsive">
            <data-table :columns="columns" :ajax="ajax" :searching="false" :order="[3, 'desc']"></data-table>
        </div>
    </div>
</template>
  
<script>
import Layout from '@/Layouts/Master'
import { Head, Link } from '@inertiajs/vue3'
import InputText from '@/Forms/InputText'
import DataTable from '@/Forms/DataTable'

export default {
    layout: Layout,
    components: {
        Head,
        Link,
        InputText,
        DataTable,
    },
    data() {
        return {
            columns: [
                { title: 'No', data: 'DT_RowIndex', orderable: false, searchable: false },
                { title: 'Operator', data: 'user.name' },
                { title: 'Diskripsi', data: 'description' },
                { title: 'Waktu', data: 'created_at' }
            ],
            ajax: {
                url: '/datatables/adminlog',
                data: function (d) {
                    d.operator = $("input[name=operator]").val()
                    d.description = $("input[name=description]").val()
                },
            },
        }
    },
    mounted() {
        $('.filter-input').keyup(function (e) {
            $("#dt-table").DataTable().ajax.reload()
            e.preventDefault();
        })
    }
}
</script>
  